const mEditionProductAssetsIncludedAssets = {
  mEditionProductAssetsIncludedAssets: {
    actions: {
      add: 'Incluir',
      remove: 'Quitar'
    },

    alerts: {
      updateProductoProyectos: {
        success: 'Cursos inlcuidos actualizados exitosamente.',
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.'
      }
    },

    buttonSecondary: {
      addAllText: 'Incluir Todos',
      removeAllText: 'Quitar Todos'
    },

    quote: {
      firstText: 'Aún no tienes cursos publicados para incluir en la venta de tu producto.',
      secondText: 'Aún no tienes cursos incluidos en tu producto.',
      thirdText: 'Selecciona uno o varios cursos para vender, estos solo pueden ser incluidos mientras estén publicados.',
      fourthText: 'Si seleccionas más de un curso puedes venderlos como un pack de formación.'
    },

    subTitles: {
      included: 'Incluidos',
      notIncluded: 'No Incluidos'
    }
  }
}

export default mEditionProductAssetsIncludedAssets
